import { UpgradeSusdcDialogContentContainer } from './UpgradeSusdcDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

function UpgradeSusdcDialog({ open, setOpen }: CommonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent spacing="none" preventAutoFocus>
        <UpgradeSusdcDialogContentContainer closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const upgradeSusdcDialogConfig: DialogConfig<CommonDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: UpgradeSusdcDialog,
  name: 'UpgradeSusdcDialog',
}
